import React, { ReactElement } from 'react';
import {
  ModalMenu as ModalMenuComponent,
  Props as ModalMenuProps,
} from 'b2b-components/theme/components/Header/ModalMenu';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { LANGUAGE_CODE } from 'b2b-common/core/i18n/consts';
import { ComponentType, Props } from './';

export const ModalMenu: ComponentType = (props: Props): ReactElement => {
  const t = useTranslate();

  const text = {
    catalog: t('Assortment'),
    brands: t('Brands'),
    home: t('Home'),
    logout: t('Logout'),
    seeAll: t('See all'),
    ariaCloseModalMobile: t('Close menu'),
    ariaLabelMobile: t('Menu'),
  };

  return (
    <ModalMenuComponent
      {...{ ...props, text } as ModalMenuProps<LANGUAGE_CODE>}
    />
  );
};
